// app/javascript/controllers/german_postcode_validator_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "errorMessage"]

  connect() {
  }

  validate() {
    const postalCode = this.fieldTarget.value;
    const regex = /^[0-9]{5}$/; // German postal codes are 5 digits
    if (!regex.test(postalCode)) {
      this.fieldTarget.classList.add('is-danger');
      this.errorMessageTarget.textContent = "Ungültige PLZ";
      return false;
    } else {
      this.fieldTarget.classList.remove('is-danger');
      this.errorMessageTarget.textContent = ""; // Clear error message
      return true;
    }

  }

  blur() {
    this.element.removeEventListener('input', this.validate);
    const result = this.validate();
    this.element.addEventListener('input', () => {
      this.validate();
    });
    return result;
  }
}
